<template>
  <div class="category-container">
    <section class="w1312 main-content-wrap">
      <div class="tab-container">
        <ul class="clearfix">
          <li v-for="(item, index) in computedCategories" :key="index" :class="{'active': item.categoryId === this.activeName}" @click="toggleTab(item.categoryId)"  mars_sead="vschool_searchlanding_searchclass_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'searchclass': item.categoryName, 'categoryId': item.categoryId})">
            {{item.categoryName}}({{item.courseCount}})
            <span class="line"></span>
          </li>
        </ul>
      </div>
    </section>
  </div>
  <section class="w1312 main-content-wrap">
    <section class="main-content clearfix mrg-btm-20">
      <div class="lefter-container">
        <view-container :loading="loading" :empty="empty" :error="error" @retry="refresh">
          <div class="info-container">
            <ul>
              <li v-for="(item, index) in courseList" :key="index">
                <template v-if="!item.examItemDTO">
                  <router-link :to="{ name: 'CourseDetail', params: {target: sessionTarget, courseId: item.courseId}}" target="_blank"  mars_sead="vschool_searchlanding_searchcourse_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'searchclass': activeName, 'courseId': item.courseId})">
                    <dl class="summary">
                      <dt>
                        <imgWrap :src="item.coverUrl" width="164" height="105" :alt="item.title" :item="item" :pic="'coverUrl'"/>
                      </dt>
                      <dd>
                        <p class="title" v-html="item.title"></p>
                        <p class="desc" v-html="item.descriptionPart"></p>
                      </dd>
                    </dl>
                  </router-link>
                  <router-link :to="{ name: 'ChapterDetail', params: {target: sessionTarget, courseId: item.courseId, chapterId: item2.chapterId}}" mars_sead="vschool_searchlanding_searchchapter_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'searchclass': activeName, 'courseId': item.courseId, chapterId: item2.chapterId})" target="_blank"  v-for="(item2, index2) in item.searchedChapters" :key="index2">
                    <dl class="info clearfix">
                      <dt>章节{{index2 + 1}}</dt>
                      <dd>
                        <span v-html="item2.title"></span>
                        <span v-html="item2.contentPart"></span>
                      </dd>
                    </dl>
                  </router-link>
                  <p class="update-time">{{item.releaseDate}}</p>
                </template>
                <template v-else>
                  <div class="info-list clearfix">
                    <div class="info-right">
                      <examLink :item="item.examItemDTO"></examLink>              
                    </div>
                    <div class="info-left">
                      <div class="exam-title">
                        <span class="pass" v-if="item.examItemDTO.lastExamResult === 1">已通过</span>
                        <span class="noPass" v-else>未通过</span>
                        <span class="highlight" v-html="item.examItemDTO.title || '~'"></span>
                      </div>
                      <div class="module-box mrg-top-10">
                        <span class="item-box">
                          及格：{{formatScore(item.examItemDTO.passScore)}}
                        </span>
                        <span class="item-box" v-if="item.lastExamResult === 1">
                          得分：{{formatScore(item.score)}}
                        </span>
                        <span class="item-box">
                          总分：{{formatScore(item.examItemDTO.totalScore)}}
                        </span>
                        <span class="item-box">
                          ID：{{item.examItemDTO.examNo}}
                        </span>
                      </div>
                      <div class="module-box">
                        <!-- <span class="item-box">
                          题目总数：{{item.questionCount}}
                        </span> -->
                        <span class="item-box">
                          时长：{{formatDuration(item.examItemDTO.duration)}}
                        </span>
                        <span class="item-box" v-if="item.lastExamResult === 1">
                          完成时间：{{formatTime(item.completedTime)}}
                        </span>
                        <span class="item-box">
                          截止时间：{{formatTime(item.examItemDTO.deadline)}}
                        </span>
                        <span class="item-box">
                          交卷人数：{{item.examItemDTO.finishCount}}
                        </span>
                      </div>
                      <div class="module-box">
                        <span class="item-box">
                          简介：
                          <span class="highlight" v-html="item.examItemDTO.examIntro || '~'"></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </li>
            </ul>
          </div>
          <div class="loading-data" v-if="loadingData">
            <view-container :loading="loadingData" :empty="false" :error="false">
            </view-container>
          </div>
          <div class="no-more" v-if="!loadingData && !afterCourseId"></div>
        </view-container>
      </div>
      <div class="righter-container" :class="{'hide': !historyList && !historyList.length && !hotKeywords && !hotKeywords.length}">
        <div class="history-container" v-if="!!historyList.length">
          <div class="history-title">
            历史搜索
          </div>
          <div class="history-content">
            <router-link :to="{'name': 'Search', params: {target: sessionTarget}, query: {'keywords': item}}" :title="item" v-for="(item, index) in historyList" :key="index" @click="$send('vschool_searchlanding_searchhistory_buttonclick')">
              <span>
                {{item}}
              </span>
            </router-link>
          </div>
        </div>
        <div class="right-line" v-if="!!historyList.length && !!hotKeywords.length"></div>
        <div class="history-container" v-if="!!hotKeywords.length">
          <div class="history-title">
            热门搜索
          </div>
          <div class="history-content">
            <router-link :to="{'name': 'Search', params: {target: sessionTarget}, query: {'keywords': item.keyword}}" :title="item.keyword" v-for="(item, index) in hotKeywords" :key="index" @click="$send('vschool_searchlanding_searchpopularview_buttonclick')">
              <span>
                <i :class="{'fire': item.fire}"></i>
                {{item.keyword}}
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import imgWrap from '@/components/imgWrap'
import mixins from '../examCenter/mixins'
export default {
  name: '',
  mixins: [mixins],
  data () {
    return {
      activeName: '',
      keywords: '',
      pageDTO: {
        afterKey: '',
        pageSize: 50
      },
      loading: false,
      empty: false,
      error: false,
      loadingData: false,
      timer: null
    }
  },
  computed: {
    ...mapState(['sessionTarget', 'queryUserPromise']),
    ...mapState('search', ['hotKeywords', 'categories', 'afterCourseId', 'courseList', 'historyList']),
    computedCategories () {
      let categories = JSON.parse(JSON.stringify(this.categories))
      let count = 0
      categories.forEach((item) => {
        count += item.courseCount
      })
      categories.unshift({
        categoryId: '',
        categoryName: '全部',
        courseCount: count
      })
      return categories
    },
    isExam () {
      return this.courseList.length && this.courseList[0].examItemDTO || false
    }
  },
  mounted () {
    this.queryUserPromise.then(() => {
      this.updateSearchStatus(true)
      this.refresh()
    })
  },
  beforeUnmount () {
    clearTimeout(this.timer)
    this.updateSearchStatus(false)
    this.updateHotKeywords(this.hotKeywords.slice(0, 5))
  },
  methods: {
    refresh () {
      const {
        keywords
      } = this.$route.query
      this.keywords = keywords
      this.cleanCourseList()
      this.clearScore()
      this.loading = true
      this.error = false
      this.empty = false
      this.queryCoursePrimaryCategories(this.keywords)
      this.getHotKeywords(16)
      this.loadData().then((resp) => {
        if (!resp.searchedCourses.length) {
          this.empty = true
        }
      }).catch(() => {
        this.error = true
      }).finally(() => {
        this.loading = false
      })
      this.searchHistory()
      this.bindLoadData()
    },
    bindLoadData () {
      let _this = this
      let top = document.documentElement.scrollTop || document.body.scrollTop
      let height = document.documentElement.offsetHeight || document.body.offsetHeight
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      if (!_this.loadingData && top + windowHeight + 370 >= height && _this.afterCourseId) {
        _this.loadingData = true
        _this.loadData(_this.afterCourseId).finally(() => {
          _this.loadingData = false
        })
      }
      clearTimeout(_this.timer)
      _this.timer = setTimeout(() => {
        _this.bindLoadData()
      }, 250)
    },
    loadData (afterKey) {
      const {
        pageSize
      } = this.pageDTO
      return new Promise((resolve, reject) => {
        this.searchCourses({
          keyword: this.keywords,
          categoryId: this.activeName || undefined,
          afterKey: afterKey || undefined,
          size: pageSize
        }).then((resp) => {
          resolve(resp)
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    toggleTab (activeName) {
      this.activeName = activeName
      this.loading = true
      this.error = false
      this.empty = false
      this.cleanCourseList()
      this.clearScore()
      this.loadData().then((resp) => {
        if (!resp.searchedCourses.length) {
          this.empty = true
        }
      }).catch(() => {
        this.error = true
      }).finally(() => {
        this.loading = false
      })
    },
    ...mapMutations('search', ['updateSearchStatus', 'cleanCourseList', 'updateHotKeywords', 'clearScore']),
    ...mapActions('search', ['getCompletionSuggester', 'getHotKeywords', 'searchCourses', 'searchHistory', 'queryCoursePrimaryCategories'])
  },
  components: {
    imgWrap
  }
}
</script>

<style lang="scss" scoped>
.category-container {
  background: #fff;
}
.tab-container {
  background: #fff;
  height: 34px;
  line-height: 34px;
  font-weight: 400;
  color: #666;
  font-size: 18px;
  padding: 24px 0 16px;
  ul {
    text-align: left;
    li {
      display: inline-block;
      line-height: 34px;
      margin-right: 48px;
      position: relative;
      cursor: pointer;
      .line {
        position: absolute;
        left: 50%;
        top: 80%;
        width: 20px;
        height: 3px;
        background: #FF2F5D;
        margin-top: 10px;
        margin-left: -10px;
        display: none;
      }
    }
    .active {
      color: #333;
      font-weight: 600;
      .line {
        display: block;
      }
    }
  }
}
.main-content {
  display: flex;
  margin-top: 40px;
  .lefter-container  {
    flex: 1;
    min-width: 977px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    padding: 32px;
    box-sizing: border-box;
    position: relative;
    /deep/ .highlight {
      i {
        font-style: normal;
        color: #ff005c;
      }
    }
    ul {
      li {
        border-bottom: 1px solid #F3F5F7;
        margin: 0 0 32px;
        padding-bottom: 32px;
        position: relative;
        &:last-child {
          border-bottom: 0;
        }
        a:hover {
          color: #666;
        }
        dl.summary {
          display: flex;
          margin-right: 180px;
          dt {
            max-width: 164px;
            width: 164px;
            height: 105px;
            margin-right: 16px;
          }
          dd {
            .title {
              font-size: 18px;
              font-weight: 600;
              color: #333;
              line-height: 26px;
              margin-bottom: 14px;
            }
            .desc {
              font-size: 14px;
              color: #666;
              line-height: 20px;
            }
            :deep(i) {
              color: #FF005C;
              font-style: normal;
            }
          }
        }
        dl.info {
          background: #F3F5F7;
          border-radius: 4px;
          overflow: hidden;
          margin-top: 16px;
          color: #666;
          padding: 10px 0 10px 24px;
          margin-right: 180px;
          box-sizing: border-box;
          dt {
            float: left;
            border: 1px solid #999;
            padding: 2px 8px;
            overflow: hidden;
            font-size: 12px;
            border-radius: 4px;
          }
          dd {
            float: left;
            width: auto;
            max-width: 650px;
            font-size: 14px;
            display: flex;
            padding-top: 2px;
            span {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &:first-child {
                float: left;
                flex: inherit;
                max-width: 140px;
                margin-right: 10px;
                margin-left: 8px;
              }
              &:last-child {
                max-width: 510px;
              }
            }
          }
          :deep(i) {
            color: #FF005C;
            font-style: normal;
          }
        }
        p.update-time {
          position: absolute;
          right: 0;
          top:0;
          text-align: right;
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
  .righter-container {
    flex: 1;
    width: 317px;
    max-width: 317px;
    background: #fff;
    border-radius: 8px;
    padding: 32px;
    box-sizing: border-box;
    margin-left: 24px;
    overflow: hidden;
    .right-line {
      height: 1px;
      overflow: hidden;
      background: #F3F5F7;
      width: 219px;
      margin-top:20px;
      margin-bottom: 30px;
    }
    .history-container {
      width: 253px;
      .history-title {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        padding-bottom: 24px;
        padding-top: 32px;
        &:first-child {
          padding-top: 0;
        }
      }
      .history-content {
        span {
          display: inline-block;
          border-radius: 4px;
          background: #F3F5F7;
          padding: 7px 8px;
          margin-right: 8px;
          margin-bottom: 12px;
          font-weight: 400;
          font-size: 14px;
          color: #666;
        }
        .fire {
          display: inline-block;
          background: url(../../assets/img/icon-fire.png);
          background-size: 12px;
          width: 12px;
          height: 12px;
        }
      }
    }
  }
}
.no-more {
  background: url(../../assets/img/pic-nomore.png) top center no-repeat;
  background-size: 110px 14px;
  height: 18px;
}
.loading-data {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -20px;
  div {
    min-height: 40px;
  }
  :deep(.loading-container) {
    min-height: 40px!important;
  }
}
.info-container {
  min-height: 216px;
  border-radius: 8px;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  .info-list {
    border-bottom: 1px solid #F3F5F7;
    // padding-top: 32px;
    // padding-bottom: 32px;
    &:last-child {
      border-bottom: 0px;
    }
  }
  .info-left {
    margin-right: 150px;
  }
  .info-right {
    float: right;
    .button {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      background-color:#FD3374;
      color: #fff;
      width: 104px;
      height: 34px;
      line-height: 34px;
      border-radius: 20px;
      margin-top: 35px;
      margin-left: 10px;
      padding: 0 10px;
      &.info {
        border: 1px solid #D3D6DA;
        background: #fff;
        color:#666;
      }
      &:hover {
        color:#fff;
      }
    }
  }
  .exam-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    color: #333;
    .pass {
      display: inline-block;
      background:#21A663;
      border-radius: 4px;
      color: #fff;
      font-size: 12px;
      margin-right: 10px;
      line-height: 18px;
      height: 18px;
      padding: 0 4px;
    }
    .noPass {
      display: inline-block;
      background:#F6445D;
      border-radius: 4px;
      color: #fff;
      font-size: 12px;
      margin-right: 10px;
      line-height: 18px;
      height: 18px;
      padding: 0 4px;
    }
  }
  .module-box {
    .item-box {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #999;
      padding: 3px 0;
      margin-right: 26px;
    }
  }
}

</style>
